// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3feyj","label":"CategoryService_label__w7wSV","location":"CategoryService_location__6NVYa"};